class PostalCodeValidation {
	setDomElements(e) {
		const postalCodeValidationBlock = e.target.closest(
			'.js-postal-code-validation-block',
		);

		this.postalCodeInput = postalCodeValidationBlock.querySelector(
			'.js-validate-postal-code-input',
		);

		this.otherInputs =
			postalCodeValidationBlock.querySelectorAll('.js-validate-input');

		this.postalCodePattern = this.postalCodeInput.dataset.pattern;

		this.errorMsg = postalCodeValidationBlock.querySelector(
			'.js-validation-error-msg',
		);

		this.postalCodeFormErrorText =
			document.getElementById('postalCodeFormText');

		this.sameAddressCheckbox = document.querySelector('#sameAsAddressCheckBox');
	}

	validationOnChange() {
		this.resetPostalCodeInput();

		const postalCodeValueWithoutSpaces = this.getPostalCodeValueWithoutSpaces();

		if (postalCodeValueWithoutSpaces.match(this.postalCodePattern)) {
			this.postalCodeInput.classList.add('valid');
			if (this.otherInputs.length > 0) {
				this.otherInputs.forEach(input => {
					input.disabled = false;
				});
			}
		} else {
			this.postalCodeInput.classList.remove('valid', 'is-valid');
		}
	}

	getPostalCodeValueWithoutSpaces() {
		const regex = /\s+/g;

		return this.postalCodeInput.value.replace(regex, '');
	}

	disableOtherInputs() {
		if (this.otherInputs.length > 0) {
			this.otherInputs.forEach(input => {
				if (!input.disabled) {
					input.value = '';
					input.disabled = true;
					input.classList.remove('invalid');
				}
			});
		}
	}

	validationOnBlur() {
		const postalCodeValueWithoutSpaces = this.getPostalCodeValueWithoutSpaces();

		if (postalCodeValueWithoutSpaces.length) {
			if (!postalCodeValueWithoutSpaces.match(this.postalCodePattern)) {
				this.postalCodeInput.classList.remove('valid');
				this.postalCodeInput.classList.add('invalid');

				if (this.errorMsg) {
					this.errorMsg.classList.remove('hidden');
				}
			} else {
				this.postalCodeInput.classList.remove('is-invalid');

				if (this.postalCodeFormErrorText) {
					this.postalCodeFormErrorText.innerHTML = '';
				}

				if (this.postalCodeInput.closest('div').querySelector('.error')) {
					this.postalCodeInput.closest('div').querySelector('.error').remove();
				}

				this.formatPostalCode();
			}
		} else {
			this.postalCodeInput.value = '';
		}
	}

	resetPostalCodeInput() {
		this.postalCodeInput.classList.remove(
			'valid',
			'is-valid',
			'invalid',
			'is-invalid',
		);
		if (this.errorMsg) {
			this.errorMsg.classList.add('hidden');
		}
		if (this.postalCodeFormErrorText) {
			this.postalCodeFormErrorText.innerHTML = '';
		}
		if (this.postalCodeInput.closest('div').querySelector('.error')) {
			this.postalCodeInput.closest('div').querySelector('.error').remove();
		}
		if (this.postalCodeInput.closest('div').classList.contains('has-error')) {
			this.postalCodeInput.closest('div').classList.remove('has-error');
		}
	}

	formatPostalCode() {
		const currentCountry = document.querySelector('.js-current-country');
		const typedPostalCode = this.postalCodeInput.value;
		if (!currentCountry || !typedPostalCode.trim()) return;

		const regex = /\s+/g;
		let formattedPostalCode = typedPostalCode.replace(regex, '').toUpperCase();

		const countryFormats = {
			en: 3, // UK: 3 characters from the end
			nl: 2, // NL: 2 characters from the end
			en_IE: 4, // IE: 4 characters from the end
		};

		const country = currentCountry.value;
		const endSpace = countryFormats[country];

		if (endSpace && formattedPostalCode.length > endSpace) {
			formattedPostalCode = this.addEmptySpaceToPostalCodeFromEnd(
				formattedPostalCode,
				endSpace,
			);
		}

		this.postalCodeInput.value = formattedPostalCode;
	}

	addEmptySpaceToPostalCodeFromEnd(postalCode, countFromEnd) {
		const splitIndex = postalCode.length - countFromEnd;
		return `${postalCode.substring(0, splitIndex)} ${postalCode.substring(splitIndex)}`;
	}

	actionsForEvents(e) {
		if (e.target.classList.contains('js-validate-postal-code-input')) {
			this.setDomElements(e);

			if (this.postalCodeInput.listenersAttached) return;
			this.postalCodeInput.listenersAttached = true;

			this.postalCodeInput.addEventListener('input', () => {
				this.disableOtherInputs();
				this.validationOnChange();
			});

			this.postalCodeInput.addEventListener('paste', () => {
				this.postalCodeInput.dispatchEvent(
					new Event('focus', { bubbles: true }),
				);
				this.disableOtherInputs();
				this.validationOnChange();
			});

			this.postalCodeInput.addEventListener('blur', () => {
				this.validationOnBlur();
			});

			if (
				this.sameAddressCheckbox &&
				!this.sameAddressCheckbox.listenersAttached
			) {
				this.sameAddressCheckbox.listenersAttached = true;
				this.sameAddressCheckbox.addEventListener('change', () => {
					this.resetPostalCodeInput();
				});
			}
		}
	}

	listeners() {
		if (document.querySelector('.js-input-validation-wrapper')) {
			document.addEventListener('pointerdown', e => {
				this.actionsForEvents(e);
			});

			document.addEventListener('focusin', e => {
				this.actionsForEvents(e);
			});
		}
	}

	init() {
		this.listeners();
	}
}

export default PostalCodeValidation;
